import { getUpdatedLangReturnToURL } from 'src/dataLayer/localData/queryParams/returnToURLHelpers';

export type QueryParams = { [key: string]: string } | URLSearchParams | string;

const EMPTY_STRING = '';

/*
 * Used to validate the returnToUrl in query params and sanitize if needed
 * Returns the query string from all query params of a URL (futher blacklisting possible)
 */
export const getValidatedQueryStringFromParams = (
  queryParams: QueryParams,
  learnLang: string
): string => {
  const searchParams = new URLSearchParams(queryParams);

  if (searchParams.has('return_to')) {
    searchParams.set('return_to', getUpdatedLangReturnToURL(queryParams, learnLang));
  };

  const queryString = searchParams.toString();
  return queryString.length > 0 ? `?${queryString}` : EMPTY_STRING;
};

/*
 * Merges the query params from the current URL to a given URL
 */
export const mergeUrlParams = (
  url: string,
  queryParams: QueryParams
): string => {
  const parsedUrl = new URL(url);

  if (Object.keys(queryParams).length === 0 || queryParams === '') return parsedUrl.href;

  const separator = parsedUrl.search ? '&' : '?';

  return `${(parsedUrl.href)}${separator}${new URLSearchParams(queryParams).toString()}`;
};
